import { Bid } from 'modules/domain/bid/types'
import { FC, useMemo } from 'react'
import { ATableFullPageWithoutData } from 'views/components/Table/ATableFullPageWithoutData'

import useBidPriceColumns from './useBidPriceColumns'
import { type User } from 'modules/domain/user/types'
import { TableDataObject } from 'modules/domain/common/hooks'
import { InternalTableFullPageWithoutDataProps } from 'views/components/Table/InternalTableFullPageWithoutData'

type BidPricesTableProps = {
  topBid?: string
  nested?: boolean
  tableData: TableDataObject<Bid>
  paramsData: ParamsData
  user?: User
}

type ParamsData = Pick<InternalTableFullPageWithoutDataProps, 'listParamsUpdated' | 'listRequestParams'>

const BidPricesTable: FC<BidPricesTableProps> = ({ topBid, nested = false, tableData, paramsData }) => {
  const columns = useBidPriceColumns({
    refetch: () => {
      return tableData.refetch(true)
    },
    nested,
    sortParam: paramsData.listRequestParams.sort,
  })

  const rowClassName = (record, index) => {
    if (nested) {
      return ''
    }
    if (index === 0 && topBid && record.id === Number(topBid)) {
      return 'bold-row'
    }
    return ''
  }

  // move single periods futures to root level
  const data = useMemo(() => tableData.data ?? [], [tableData])

  return (
    <ATableFullPageWithoutData
      rowClassName={rowClassName}
      columns={columns}
      rowHoverGray
      {...tableData}
      {...paramsData}
      data={data}
    />
  )
}

export default BidPricesTable
